/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as useCreatable } from '../use-creatable';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { CreatableProps } from '../creatable';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default } from '../creatable';
